import Flex from "../../../../../components/Flex";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import Text from "../../../../../components/Text";
import ProfileViewer from "../../../../../components/ProfileViewer";
import { formatDate } from "../../../../../utils/date-time-utility";
import { GENDER_RECORD } from "../../../../../constants";
import { getFormattedId, getValueFromObj } from "../../../../../utils/utils";
import OutlineCard from "../../../../../components/OutlineCard";
import { useGetPatientPaymentById } from "../../../../../queries/billings/payments/use-get-patient-payment-by-id";
import EnterSuperBills from "./EnterSuperBills";
const UpdatePayment = ({
  disclosureHost,
  title,
}: {
  disclosureHost: DisclosureHost;
  title?: string;
}) => {
  // const isReferralOut = useQueryParams("activeReferral") === "referral-out";

  // const isReferralIn = useQueryParams("activeReferral") === "referral-in";
  const { data } = useGetPatientPaymentById({
    patientPaymentId: disclosureHost?.data,
  });

  const patientPaymentData = data?.data;
  return (
    <SideSheetDrawer
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      title={title || "Payment"}
      w="900px"
    >
      {patientPaymentData && (
        <>
          {/* patient section  */}
          <Flex gap={1} width={"100%"} height={"100%"} mt={2}>
            <OutlineCard
              style={{
                height: "50%",
                padding: "15px",
                overflow: "auto",
                width: "100%",
              }}
            >
              <Flex
                style={{
                  height: "50%",
                  padding: "2px",
                  overflow: "auto",
                  flexDirection: "column",
                }}
              >
                <Text variant="h4" fontWeight={"medium"}>
                  Patient Details
                </Text>
                <Flex gap={1} mt={3} justifyContent={"space-between"}>
                  <ProfileViewer
                    gap={"10px"}
                    firstColW={3}
                    secondColW={8}
                    data={{
                      Name:
                        getValueFromObj((patientPaymentData as any)?.patient) ??
                        "",
                      DOB:
                        formatDate((patientPaymentData as any)?.patientDOB) ??
                        "",
                      Gender:
                        GENDER_RECORD[
                          (patientPaymentData as any)?.patientGender
                        ] ?? "",
                      Address: "",
                    }}
                  />
                </Flex>
              </Flex>
            </OutlineCard>
          </Flex>
          {/* Bill and visit details */}
          <Flex gap={1} width={"100%"} height={"100%"} mt={10}>
            <OutlineCard
              style={{
                height: "50%",
                padding: "15px",
                overflow: "auto",
                width: "100%",
              }}
            >
              <Flex
                style={{
                  height: "50%",
                  padding: "2px",
                  overflow: "auto",
                  flexDirection: "column",
                }}
              >
                <Text variant="h4" fontWeight={"medium"}>
                  Bill and Visit Details
                </Text>
                <Flex gap={1} mt={3} justifyContent={"space-between"}>
                  <ProfileViewer
                    gap={"10px"}
                    firstColW={3}
                    secondColW={8}
                    data={{
                      "Invoice ID": (patientPaymentData as any)?.billIds
                        ? Object.keys((patientPaymentData as any)?.billIds)
                            .map((id) => getFormattedId(id))
                            .filter(Boolean)
                            .join(", ")
                        : "",
                      "Visit ID": (patientPaymentData as any)?.visitIds
                        ? Object.keys((patientPaymentData as any)?.visitIds)
                            .map((id) => getFormattedId(id))
                            .filter(Boolean)
                            .join(", ")
                        : "",
                      Provider:
                        getValueFromObj(
                          (patientPaymentData as any)?.billingProvider
                        ) ?? "",
                    }}
                  />
                </Flex>
              </Flex>
            </OutlineCard>
          </Flex>
          {/* Transaction Information */}
          <Flex gap={1} width={"100%"} height={"100%"} mt={10}>
            <OutlineCard
              style={{
                height: "50%",
                padding: "15px",
                overflow: "auto",
                width: "100%",
              }}
            >
              <Flex
                style={{
                  height: "50%",
                  padding: "2px",
                  overflow: "auto",
                  flexDirection: "column",
                }}
              >
                <Text variant="h4" fontWeight={"medium"}>
                  Transaction Information
                </Text>
                <Flex gap={1} mt={3} justifyContent={"space-between"}>
                  <ProfileViewer
                    gap={"10px"}
                    firstColW={3}
                    secondColW={8}
                    data={{
                      "Payment Date":
                        formatDate((patientPaymentData as any)?.paymentDate) ??
                        "",
                      "Type Of Payment":
                        (patientPaymentData as any)?.typeOfPayment === "PATIENT"
                          ? "Patient Payment"
                          : (patientPaymentData as any)?.typeOfPayment ===
                              "INSURANCe"
                            ? "Insurance Payment"
                            : "",
                      "Transaction Id":
                        (patientPaymentData as any)?.transactionId ?? "",
                      "Payment Mode":
                        (patientPaymentData as any)?.paymentMode ?? "",
                      "Payment Method":
                        (patientPaymentData as any)?.bankPaymentMode ?? "",
                    }}
                  />
                </Flex>
              </Flex>
            </OutlineCard>
          </Flex>
          {/* Amount details */}
          <Flex gap={1} width={"100%"} height={"100%"} mt={10}>
            <OutlineCard
              style={{
                height: "50%",
                padding: "15px",
                overflow: "auto",
                width: "100%",
              }}
            >
              <Flex
                style={{
                  height: "50%",
                  padding: "2px",
                  overflow: "auto",
                  flexDirection: "column",
                }}
              >
                <Text variant="h4" fontWeight={"medium"}>
                  Amount Details
                </Text>
                <Flex gap={1} mt={3} justifyContent={"space-between"}>
                  <ProfileViewer
                    gap={"10px"}
                    firstColW={3}
                    secondColW={8}
                    data={{
                      Amount:
                        (patientPaymentData as any)?.amount?.toString() ?? "",
                      "Applied Amount":
                        (
                          patientPaymentData as any
                        )?.appliedAmount?.toString() ?? "",
                      "Unapplied Amount":
                        (
                          patientPaymentData as any
                        )?.unappliedAmount?.toString() ?? "",
                    }}
                  />
                </Flex>
              </Flex>
            </OutlineCard>
          </Flex>

          {/*   Note */}
          <Flex gap={1} width={"100%"} height={"100%"} mt={10}>
            <OutlineCard
              style={{
                height: "50%",
                padding: "15px",
                overflow: "auto",
                width: "100%",
              }}
            >
              <EnterSuperBills
                viewOnly={true}
                billIds={
                  (patientPaymentData as any)?.billIds
                    ? Object.keys((patientPaymentData as any)?.billIds).map(
                        (it) => {
                          return {
                            value: it,
                            label: "",
                          };
                        }
                      )
                    : []
                }
                onClose={() => {}}
              />
            </OutlineCard>
          </Flex>
        </>
      )}
    </SideSheetDrawer>
  );
};

export default UpdatePayment;
